import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-to-top"
      className="fixed bottom-[calc(6rem+env(safe-area-inset-bottom,0px))] sm:bottom-24 left-4 md:left-6 z-[9998] w-10 h-10 rounded-full bg-[#0EA5E9] text-white shadow-lg flex items-center justify-center hover:bg-[#0284C7] transition-all hover:scale-110 active:scale-95"
      aria-label="Scroll to top"
    >
      <ChevronUp className="w-5 h-5" />
    </button>
  );
}
